import { Maybe } from "types";

// The name becomes a storage object key, so strip anything that could form
// a path segment ("../", "/") or break the public URL.
const sanitizeName = (name: Maybe<string>) => (name || "site").replace(/[^\w-]/g, "_");

export const createSitePath = (name: Maybe<string>) =>
  `${sanitizeName(name)}-${new Date().getTime()}.png`;
